<template>
    <div class="flex-1">
        <div class="row mx-5 mt-3">
          <div class="alert alert-warning" role="alert" v-if="isScope === 'no'">
            Обновите приложение Трекер посылок 2 из магазина Битрикс24
          </div>
        </div>
        <div class="row mx-5 mt-3" v-if="loadError">
          <div class="alert alert-danger" role="alert">
            Неполучилось загрузить данные. Попробуйте перезагрузить страницу.
          </div>
        </div>
        <!-- <payForm /> -->
        <h4 class="px-5 mt-3">Подключенные/неподключенные интеграции</h4>
        <div class="row mx-5 px-0">
          <div class="col-md-3 px-0">
            <div v-for="(item, i) in success_array" :key="i" class="d-flex flex-row align-items-center"><i class="fas fa-check mr-3"></i>{{ item.name }}</div>
          </div>
          <div class="col-md-3 px-0" >
              <div v-for="(item, i) in error_array" :key="i" class="d-flex flex-row align-items-center"><i class="fas fa-times mr-3"></i>{{ item.name }}</div>
          </div>
        </div>
        <h4 class="px-5 mt-5">Запустить проверку трек-номеров в сделках</h4>
        <div class="row mx-5 px-0">
          После нажатия, мы запустим проверку трек-номеров для вашего портала и все отслеживаемые сделки получат новую информацию. Нажимайте, тогда, когда хотите проверить настройки или получить информацию.
        </div>
        <div class="row mx-5 px-0 mb-2">
          Приложение автоматически запускает проверку 2 раза в день: в 10 и 18 часов по мск.
        </div>
        <div class="row mx-5 px-0">
          <button type="button" class="btn btn-primary" v-on:click="startCheck">
            <span v-if="isLoad" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span v-if="!isLoad">Запустить обновление трек-номеров</span>
          </button>
        </div>
        <div class="row mx-5 px-0">
          <div v-show="alert_s_show" class="mt-2 alert alert-success my-3 col-md-6" role="alert" v-text="alert_s"></div>
          <div v-show="alert_e_show" class="mt-2 alert alert-danger col-md-6" role="alert" v-text="alert_e"></div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Bitrix24 from '@/lib/Bitrix24'
import common from '@/lib/common'
import urls from '@/lib/urls'
import payForm from '@/components/pay_form'

export default {
  name: 'Home',
  components: {
    payForm
  },
  data: function() {
    return {
      success: '',
      error: '',
      loadError: false,
      success_array: [],
      error_array: [],
      isScope: 'loading',
      isLoad: false,
      alert_s: '',
      alert_e: '',
      alert_e_show: false,
      alert_s_show: false
    }
  },
  async mounted() {
    const self = this

    Bitrix24.callMethod('scope', {}).then(response => {
      let result = response.data()
      if(result.find(e => e === 'placement')){
        self.isScope = 'yes'
      } else{
        self.isScope = 'no'
      }
    }).catch(error => {
      console.log(error)
    })

    axios.get(urls.getSettings, await common.setAuthorizationHeader()).then((response) => {
      response = response.data
      let array_services = [
        {"name": "Почта России", "value": "true"}, 
        {"name": "CDEK", "value": response.cdek}, 
        {"name": "Деловые Линии", "value": "true"}, 
        {"name": "Boxberry", "value": response.boxberry}, 
        {"name": "ПЭК", "value": response.pec}, 
        {"name": "DPD", "value": response.dpd}, 
        {"name": "GTD (KIT)", "value": "true"}, 
        {"name": "IML", "value": response.iml}
      ]
      let succ = []
      let err = []
      let s = array_services.length
      for(let i = 0; i < s; i++){
        if(array_services[i].value.length < 1){
          err.push({"name": array_services[i].name, "value": array_services[i].value})
        } else{
          succ.push({"name": array_services[i].name, "value": array_services[i].value})
        }
      }
      self.success_array = succ
      self.error_array = err
    }).catch(error => {
      let errorParsed = common.errorQueryHandler(error)

      if(errorParsed.type === 'unauthorization'){
        common.queryRefreshToken(error).then(response => {
          response = response.data
          let array_services = [
            {"name": "Почта России", "value": "true"}, 
            {"name": "CDEK", "value": response.cdek}, 
            {"name": "Деловые Линии", "value": "true"}, 
            {"name": "Boxberry", "value": response.boxberry}, 
            {"name": "ПЭК", "value": response.pec}, 
            {"name": "DPD", "value": response.dpd}, 
            {"name": "GTD (KIT)", "value": "true"}, 
            {"name": "IML", "value": response.iml}
          ]
          let succ = []
          let err = []
          let s = array_services.length
          for(let i = 0; i < s; i++){
            if(array_services[i].value.length < 1){
              err.push({"name": array_services[i].name, "value": array_services[i].value})
            } else{
              succ.push({"name": array_services[i].name, "value": array_services[i].value})
            }
          }
          self.success_array = succ
          self.error_array = err
        }).catch(err => {
          self.loadError = true
          console.log(err)
        })
      } else if(errorParsed.type === 'some'){
        self.loadError = true
        console.log(error)
      } else{
        self.loadError = true
        console.log(error)
      }
    })
    // BX24.callMethod(
    //   "crm.deal.fields", 
    //   {}, 
    //   function(result) 
    //   {
    //     if(result.error())
    //       console.error(result.error());
    //     else
    //       var data = result.answer.result;
    //       var a = Array.from(Object.keys(data), k=>data[k]);
    //       var b = []
    //       Object.keys(data).map((e) => {
    //         b.push({"title": data[e].title, "name": e, "label": data[e].listLabel})    
    //       })
    //       self.fields = b
    //   }
    // );
  },
  methods: {
    async startCheck(){
      const self = this

      this.isLoad = true

      this.alert_e = ''
      this.alert_e_show = false
      this.alert_s = ''
      this.alert_s_show = false

      axios.get(urls.startCheck, await common.setAuthorizationHeader()).then(response => {
        if(response.data === 'OK'){
          self.alert_s_show = true
          self.alert_s = 'Проверка успешно запущена'
        }
        self.isLoad = false
      }).catch(error => {
        let errorParsed = common.errorQueryHandler(error)

        if(errorParsed.type === 'unauthorization'){
          common.queryRefreshToken(error).then(response => {
            if(response.data === 'OK'){
              self.alert_s_show = true
              self.alert_s = 'Проверка успешно запущена.'
            }
            self.isLoad = false
          }).catch(err => {
            self.alert_e_show = true
            self.alert_e = 'Возникла ошибка: '+err
            self.isLoad = false
          })
        } else if(errorParsed.type === 'some'){
          self.alert_e_show = true
          self.alert_e = 'Возникла ошибка: '+errorParsed.error
          self.isLoad = false
        } else{
          self.alert_e_show = true
          self.alert_e = 'Возникла ошибка: '+error
          self.isLoad = false
        }
      })
    }
  },
}
</script>
<style scope>
.fa-check{
  color: #52c41a;
}
.fa-times{
  color: #f5222d;
}
</style>
